module.exports = __webpack_public_path__ + "static/smg-brand-4596d06bb9336feecac7b40231bb4135.jpg";